import { render, staticRenderFns } from "./show-release-notes-client.vue?vue&type=template&id=49d4c602&"
import script from "./show-release-notes-client.vue?vue&type=script&lang=js&"
export * from "./show-release-notes-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCheckbox,VIcon,VImg,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49d4c602')) {
      api.createRecord('49d4c602', component.options)
    } else {
      api.reload('49d4c602', component.options)
    }
    module.hot.accept("./show-release-notes-client.vue?vue&type=template&id=49d4c602&", function () {
      api.rerender('49d4c602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/show-release-notes-client.vue"
export default component.exports